/* ================ MODULES ================ */
theme.Header = (function () {
  var selectors = {
    body: "body",
    sitenav: "#siteNav",
    navLinks: "#siteNav .lvl1 > a",
    mobilenav: ".mobile-nav-wrapper",
    menuLinks: "#MobileNav li > a ",
  };
  function init() {
    $(".header-cart, .close-cart").on("click", function (i) {
      i.preventDefault();
      i.stopPropagation();
      $("#cart-drawer").toggleClass("active");
    });

    $(selectors.navLinks).each(function () {
      if ($(this).attr("href") == window.location.pathname)
        $(this).addClass("active");
    });

    $(".js-mobile-nav-toggle, .closemobileMenu").on("click", function () {
      body: "body", $(selectors.mobilenav).toggleClass("active");
      $(selectors.body).toggleClass("menuOn");
      $(".js-mobile-nav-toggle").toggleClass("open close");
    });

    $("body").click(function (event) {
      var $target = $(event.target);
      if (
        !$target.parents().is(selectors.mobilenav) &&
        !$target.parents().is(".js-mobile-nav-toggle") &&
        !$target.is(".js-mobile-nav-toggle")
      ) {
        $(selectors.mobilenav).removeClass("active");
        $(selectors.body).removeClass("menuOn");
        $(".js-mobile-nav-toggle").removeClass("close").addClass("open");
      }
      // Hide cart drawer
      if (
        !$target.parents().is("#cart-drawer") &&
        !$target.is("#cart-drawer") &&
        !$target.parents().is(".header-cart") &&
        !$target.is(".header-cart")
      ) {
        $("#cart-drawer").removeClass("active");
      }
      // Hide settingsBox on document click
      if (
        !$target.parents().is("#settingsBox") &&
        !$target.parents().is(".site-settings") &&
        !$target.is(".site-settings")
      ) {
        $("#settingsBox").removeClass("active");
      }
    });

    $(selectors.menuLinks).on("click", function (e) {
      if ($(this).hasClass("main")) {
        e.preventDefault();
        $(this).toggleClass("open close");
        $(this).next().slideToggle();
      }
    });
  }
  return { init: init };
})();
